<template>
  <section id="sso" style="height: 100vh">인증중입니다.</section>
</template>
<script>
import Util from '@/util';
import base64 from 'base64-js';
// import crypto from 'crypto-js';

export default {
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  mounted() {
    this.loading = false;
    this.login();
  },
  methods: {
    async getSettings() {
      await this.$http
        .get('/api/v1/systems')
        .then((response) => {
          this.settings = response.data;
          if (this.settings === '' || this.settings === null) {
            this.settings = Object.assign({}, this.defaultSettings);
          }
          this.$store.dispatch('setSettings', this.settings);
        })
        .catch((error) => {
          this.$store.dispatch('setSettings', this.defaultSettings);
        });
    },
    async login() {
      // get redirect url
      let redirectUrl = (await this.$http.get('/api/auth/sso/redirecturl')).data
        .redirectUrl;
      redirectUrl = `${redirectUrl}/ssoSuccess`;
        
      let ssoStatus = (await this.$http.get('/api/auth/sso/status')).data.ssoStatus;
      
      this.$bandiJS.agent.init({ isDebug: true });
      this.$bandiJS.agent.call({ requestType: 'alive' });
      this.$bandiJS.agent.call({
        requestType: 'check_login',
        isShownLoginForm: 'false',
        successCallback: async function (response) {
          //if(response && response['success']) {
          if (
            response &&
            response['success'] &&
            response.dataMap &&
            response.dataMap['is_login']
          ) {
            var pSid = response.dataMap['p_sid'];

            console.log(`response`, response);

            // pid로 ssoLoginCheck 하는 부분
            await Util.ssoLoginCheck(pSid, redirectUrl, ssoStatus);
            return;
          }

          alert('Agent에서 Login 해주세요!');
          if (ssoStatus === 'dev') {
            window.location.href = "https://sso-d.ksd.or.kr:4443/sso/auth?client_id=Conf";
          } else {
            window.location.href = "https://sso.ksd.or.kr:8443/sso/auth?client_id=DWS";
          }
        },
        errorCallback: function (response) {
          console.log(`errorCallback`, response);

          if (response && 'agent.is.off' == response.error) {
            alert('SSO agent를 실행해 주세요!');
            // window.location.href = '/login';
          }
        },
      });
      let paramUserKey = '';
      let userKey = '';
      if (this.getURLParameter('ukPk')) {
        // paramUserKey = decodeURIComponent(this.getURLParameter('ukPk')).replace(/\+/g, '%20');
        // userKey = atob(paramUserKey);
        userKey = this.getURLParameter('ukPk');
      }
      let generateKey = this.getURLParameter('generateKey');

      if (userKey) {
        this.$http
          .post('/api/auth/ssoLoginAes', { userKey: userKey })
          .then((response) => {
            if (response.data.user.status === 'r') {
              window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
              this.loading = false;
              return;
            }

            this.loginSuccess(response);
          })
          .catch((error) => {
            console.log(`error : `, error);
            alert('잘못된 접근');
            this.loading = false;
            this.error = error.response.data.error;
          });
      } else if (generateKey) {
        this.$http
          .post('/api/auth/ssoLogin', { generateKey: generateKey })
          .then((response) => {
            if (response.data.user.status === 'r') {
              window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
              this.loading = false;
              return;
            }

            this.loginSuccess(response);
          })
          .catch((error) => {
            this.loading = false;
            this.error = error.response.data.error;
          });
      }
    },
    async loginSuccess(response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 60 * 60 * 9);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;
      await this.$http
        .post('/api/auth/login/log')
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          // this.error = error.response.data.error;
        });
      await this.getSettings();
      const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
        .data;
      console.log(`loginSuccess ## isAdmin ##`, isAdmin);
      setTimeout(() => {
        if (isAdmin === true) {
          this.$router.replace('/dashboard');
        } else {
          this.$router.replace('/kMeeting');
        }
        this.loading = false;
      }, 100);
    },
    getURLParameter(sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split('&');
      for (let i = 0; i < sURLVariables.length; i++) {
        let sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1];
        }
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/SsoLogin.vue